import { useQuery, useMutation, UseQueryOptions } from "@tanstack/react-query";
import { fetchExecution, fetchExecutions, buyExecution, fetchPlayerHistory, fetchPlayerInfo, YantraExecutionInfo } from "../queries/player";

const useExecutionsQuery = (sessionId: string) => {
  return useQuery({
    queryKey: ["executions"],
    queryFn: () =>
      fetchExecutions({
        sessionId,
      }),
    staleTime: 0,
    structuralSharing: false,
  });
};

const useExecutionQuery = (
  executionId: string,
  sessionId: string,
  options?: Partial<UseQueryOptions<{ yantraExecution: YantraExecutionInfo }, Error>>
) => {
  return useQuery<{ yantraExecution: YantraExecutionInfo }, Error>({
    queryKey: ["execution", executionId],
    queryFn: () => fetchExecution({ executionId, sessionId }),
    staleTime: 0,
    structuralSharing: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...(options || {}),
  });
};

const useBuyExecutionMutation = () => {
  return useMutation({
    mutationFn: ({
      executionId,
      sessionId,
      tickets,
    }: {
      executionId: string;
      sessionId: string;
      tickets: {
        images: Record<string, number> | {};
        rows: Record<string, number> | {};
      };
    }) => buyExecution(executionId, sessionId, tickets),
    onSuccess: () => {},
    onError: (error: unknown) => {
      console.error("Error buying execution:", error);
    },
  });
};

const usePlayerHistoryQuery = (sessionId: string) => {
  return useQuery({
    queryKey: ["playerHistory"],
    queryFn: () => fetchPlayerHistory(sessionId),
    enabled: !!sessionId,
    retry: false,
  });
};

const usePlayerInfoQuery = (sessionId: string) => {
  return useQuery({
    queryKey: ["playerInfo"],
    queryFn: () => fetchPlayerInfo(sessionId),
    refetchInterval: 0,
    retry: false,
    structuralSharing: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};

export { useExecutionsQuery, useExecutionQuery, useBuyExecutionMutation, usePlayerHistoryQuery, usePlayerInfoQuery };
